import styled, { css } from 'styled-components';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

import { TransientProps } from '@common/types';

export const Container = styled(motion.dialog)`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    padding: 0 0 1rem 1rem;
    position: absolute;
    left: 0;
    width: 72%;
    height: 100%;
    background: ${theme.colors.background[100]};
    color: ${theme.colors.foreground[100]};
    z-index: 5;
    pointer-events: all;

    box-shadow: 0px 2.8px 2.2px rgba(0, 0, 0, 0.02),
      0px 6.7px 5.3px rgba(0, 0, 0, 0.028), 0px 12.5px 10px rgba(0, 0, 0, 0.035),
      0px 22.3px 17.9px rgba(0, 0, 0, 0.042),
      0px 41.8px 33.4px rgba(0, 0, 0, 0.05), 0px 100px 80px rgba(0, 0, 0, 0.07);

    > button:first-child {
      margin-left: -1rem;
    }
  `}
`;

type NavigateProps = TransientProps<{
  active: boolean;
}>;

export const NavLink = styled(Link)<NavigateProps>`
  ${({ theme, $active: isActive }) => css`
    display: flex;
    align-items: center;
    width: 100%;

    font-size: 1rem;
    font-weight: 400;
    overflow: hidden;
    white-space: nowrap;
    color: ${isActive
      ? theme.colors.brand.primary.default
      : theme.colors.foreground[100]};
    border-right: 0.25rem solid
      ${isActive
        ? theme.colors.brand.primary.default
        : theme.colors.foreground[100]};

    > svg {
      margin: 0.75rem 1.75rem 0.75rem 0.25rem;
    }

    :hover {
      color: ${theme.colors.brand.primary.default};
      border-right-color: ${theme.colors.brand.primary.default};
    }
  `}
`;

export const NavButton = styled(NavLink).attrs(() => ({
  $active: false,
}))`
  ${() => css`
    background: none;
    justify-content: flex-start;
    padding: 0;
  `}
`;
